import React, { memo, useEffect } from 'react'
import { CalendarBar, ICalendarBarProps } from 'apps/fleet-planner/components/fleet/CalendarView'
import { IDriver } from 'apps/fleet-planner/types'
import { OverflowMenu, useOverflowToggle } from 'transfix-ui'

interface IDraftFleetLoadProps extends Partial<ICalendarBarProps> {
  edges: [string, string]
  driver?: IDriver
  onHide: () => void
  onAction: (label: string) => void
}

export const FleetContextMenu = memo<IDraftFleetLoadProps>(
  ({ className, edges, onAction, onHide, overlapping, style }) => {
    const { expanded, setExpanded } = useOverflowToggle(true)

    useEffect(() => {
      if (!expanded) setTimeout(onHide, 100)
    }, [expanded, onHide])

    const dropdownOptions = [
      {
        label: 'Add Load',
        action: () => {
          onAction('create-load')
        },
      },
    ]

    return (
      <CalendarBar
        edges={edges}
        className={`fleet-bar draft ${className}`}
        style={style}
        overlapping={overlapping}>
        <OverflowMenu
          options={dropdownOptions}
          expanded={expanded}
          dropdownId='add-load-calendar'
          trigger={<div className='fleet-load draft' />}
          alignment='left'
          onExpanded={setExpanded}
        />
      </CalendarBar>
    )
  }
)
